module.exports = __webpack_public_path__ + "static/media/3.c48105be.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row5/3.wav
// module id = 86
// module chunks = 0